import {request} from '../utils/request';
import {GET, POST} from '../constants/API_CONSTANTS';
import {
  GET_UBER_EATS_MERCHANT_STATUS,
  GET_UBER_EATS_STORES,
  GET_UBER_EATS_STORE_MENUS,
  POST_UBER_EATS_ONBOARDING_PROCESS
} from '../constants/API_ENDPOINTS';

const headersConfig = {
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_UBEREATS_AUTH_TOKEN}`,
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
};

export const getUberEatsMerchantStatusApi = async (merchantId) => {
  return request(GET, GET_UBER_EATS_MERCHANT_STATUS(merchantId), null, {
    ...headersConfig
  });
};

export const getUberEatsStoresApi = async (merchantId) => {
  return request(GET, GET_UBER_EATS_STORES(merchantId), null, {
    ...headersConfig
  });
};

export const getUberEatsStoreMenus = async (storeId) => {
  return request(GET, GET_UBER_EATS_STORE_MENUS(storeId), null, {
    ...headersConfig
  });
};

export const postUberEatsOnboardingProcess = async (data) => {
  return request(
    POST,
    POST_UBER_EATS_ONBOARDING_PROCESS(),
    {data},
    {
      ...headersConfig
    }
  );
};
